import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';

const VendorReport = () => {
  // Sample data - replace with actual data from your backend
  const reports = [
    {
      id: 1,
      customerName: "John Doe",
      propertyAddress: "123 Main St",
      inspectionDate: "2025-01-15",
      conversationSummary: "Customer showed high interest. Main concerns were about pricing and renovation potential."
    },
    // Add more report items as needed
  ];

  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold mb-6">Inspection Summaries</h1>
      <div className="grid gap-6">
        {reports.map((report) => (
          <Card key={report.id}>
            <CardHeader>
              <CardTitle>{report.customerName}</CardTitle>
              <p className="text-gray-600">{report.propertyAddress}</p>
              <p className="text-sm text-gray-500">Inspection Date: {report.inspectionDate}</p>
            </CardHeader>
            <CardContent>
              <h3 className="font-semibold mb-2">Conversation Summary</h3>
              <p className="text-gray-700">{report.conversationSummary}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default VendorReport;